"use client"

import * as React from "react"
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"
import { useHydrated } from "@/hooks/use-hydrated"

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

const CollapsibleContent = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content>
>(({ className, children, ...props }, ref) => {
  // The open and close animations only once the page has hydrated. Content
  // the server renders OPEN (the product page's details and reviews) would
  // otherwise play the open animation on first paint, before Radix can stop
  // it: its keyframes read --radix-collapsible-content-height, which Radix
  // only sets after hydration, so the content sat collapsed for a moment and
  // then popped open. After hydration Radix's own mount handling keeps an
  // already-open panel still, and every toggle animates as before; on a
  // client-side navigation this is true from the first render.
  const hydrated = useHydrated()
  return (
    <CollapsiblePrimitive.Content
      ref={ref}
      className={
        hydrated
          ? "overflow-hidden text-sm data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down"
          : "overflow-hidden text-sm"
      }
      {...props}
    >
      {children}
    </CollapsiblePrimitive.Content>
  )
})

CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
